import React from 'react'

export default function HeadSpace() {
  return <div className=" w-full h-[50px] "></div>
}
